import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { hideSidebar } from 'redux/navigation'
import { Button } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      push,
      hideSidebar,
    },
    dispatch
  )
}

class NavigationButton extends React.Component {
  render() {
    const { children, item, push, customProps, hideSidebar } = this.props

    return (
      <Button
        {...customProps}
        {...{
          children: children ? children : item.content,
          href: item.path,
          onClick: (event) => {
            event.preventDefault()
            push(item.path)
            hideSidebar()
          },
        }}
      />
    )
  }
}

NavigationButton = connect(mapStateToProps, mapDispatchToProps)(
  NavigationButton
)
export default NavigationButton



// WEBPACK FOOTER //
// ./src/components/shared/Navigation/renditions/NavigationButton.jsx